import { useState, FormEvent } from 'react';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9phh79n2trhb35gvfgg';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('website_alt') as string || '').trim();
    if (honeypotValue) {
      setStatus('success');
      setMessage('感谢订阅！我们会将最新资讯发送到您的邮箱。');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          email: formData.get('email') as string,
        }).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们会将最新资讯发送到您的邮箱。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '订阅失败';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setMessage('提交失败，请稍后再试。');
        } else {
          setStatus('error');
          setMessage(serverMsg);
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查您的网络连接后重试。');
    }
  };

  return (
    <section id="newsletter" className="w-full bg-background-900 py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[600px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">订阅我们的资讯</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-300 leading-relaxed">
            第一时间获取最新文章、行业动态和专属优惠信息，让精彩内容直达您的邮箱。
          </p>

          <form
            onSubmit={handleSubmit}
            data-readdy-form
            id="newsletter-form"
            className="mt-8 flex flex-col sm:flex-row gap-3"
          >
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="hp-field"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入您的邮箱地址"
              required
              className="flex-1 px-5 py-3 text-sm rounded-full bg-background-800 text-background-50 placeholder:text-foreground-500 border border-background-700 focus:outline-none focus:border-accent-500 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-8 py-3 text-sm font-medium rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 disabled:opacity-60 transition-colors whitespace-nowrap"
            >
              {status === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </form>

          {status === 'success' && (
            <p className="mt-4 text-sm text-accent-400">{message}</p>
          )}
          {status === 'error' && (
            <p className="mt-4 text-sm text-red-400">{message}</p>
          )}

          <p className="mt-4 text-xs text-foreground-500">
            我们尊重您的隐私，绝不会分享您的邮箱地址。您可以随时取消订阅。
          </p>
        </div>
      </div>
    </section>
  );
}